import { useState, useEffect } from "react";
import axios from "axios";
import envConfig from "../../bin/env.config";
import { useSelector } from "react-redux";

export default function useProjectCompanyIds(projectId = 0) {
  const token = useSelector(state => state.session.token);
  const [projectCompanyIds, setProjectCompanyIds] = useState([]);

  useEffect(() => {
    const fetchProjectBanners = async () => {
      if (projectId > 0) {
        try {
          const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/project-banners`;
          const result = await axios.post(url, { project_id: projectId }, {
            headers: {
              Authorization: token,
            },
          });
          const ids = result.data.data
            .filter(banner => banner.company_report_tool_project_id === parseInt(projectId, 10))
            .map(banner => banner.id);
          setProjectCompanyIds(ids);
        } catch (error) {
          console.error("Error fetching project banners:", error);
          setProjectCompanyIds([]);
        }
      } else {
        setProjectCompanyIds([]);
      }
    };
    fetchProjectBanners();
  }, [projectId, token]);

  return projectCompanyIds;
}
